module.exports = __webpack_public_path__ + "static/img/wolf.2e68e88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wolf.png
// module id = qkyO
// module chunks = 1